import { gql } from '@apollo/client';

export const getPriceCurveChart1 = gql`
    query getPriceCurveData(
        $xAxisAttribute: SamyaString!
        $metric: SamyaString!
        $levelAttribute: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $timePeriod: JSONString!
        $limit: Int
        $offset: Int!
    ) {
        getPriceCurveData(
            xAxisAttribute: $xAxisAttribute
            metric: $metric
            levelAttribute: $levelAttribute
            metricType: $metricType
            filters: $filters
            timePeriod: $timePeriod
            limit: $limit
            offset: $offset
        ) {
            levelsLegendLst
            data
        }
    }
`;

export const getPriceCurveChart2 = gql`
    query getIndexGraphData(
        $xAxisAttribute: SamyaString!
        $levelAttribute: SamyaString
        $metric: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $levelAttributeNames: [SamyaString]
        $timePeriod: JSONString!
        $graphName: SamyaString!
        $limit: Int
        $offset: Int!
    ) {
        getIndexGraphData(
            xAxisAttribute: $xAxisAttribute
            levelAttribute: $levelAttribute
            metric: $metric
            metricType: $metricType
            filters: $filters
            levelAttributeNames: $levelAttributeNames
            timePeriod: $timePeriod
            graphName: $graphName
            limit: $limit
            offset: $offset
        ) {
            baseLineValue
            values {
                attributeValue
                diffValue
            }
        }
    }
`;

export const priceCurveTrendsChart = gql`
    query getPriceCurveTrendChartData(
        $xAxisAttribute: SamyaString!
        $levelAttribute: SamyaString
        $metric: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $xAxisAttributeName: SamyaString!
        $graphName: SamyaString!
        $levelAttributeNames: [SamyaString]
        $timePeriod: JSONString!
        $limit: Int
        $offset: Int!
    ) {
        getPriceCurveTrendChartData(
            xAxisAttribute: $xAxisAttribute
            levelAttribute: $levelAttribute
            metric: $metric
            metricType: $metricType
            filters: $filters
            levelAttributeNames: $levelAttributeNames
            xAxisAttributeName: $xAxisAttributeName
            timePeriod: $timePeriod
            graphName: $graphName
            limit: $limit
            offset: $offset
        ) {
            data {
                startTimestamp
                periodLabel
                currentValue
                previousValue
            }
        }
    }
`;
